import { ComponentStyleConfig, Flex, FormControl, FormLabel, Switch as ChakraSwitch } from '@chakra-ui/react';
import { ChangeEvent, FC } from 'react';

import { textStyles } from 'quotient/theme/foundations/typography/typography';
import { CommonCIQProps, SelectedStyledSystemProps } from 'quotient/types';

export const SwitchStyle: ComponentStyleConfig = {
  baseStyle: {
    track: {
      bg: 'surfaceBackgroundMediumContrastReverse',
      _checked: {
        bg: 'surfaceBrandDefault',
      },
      _focus: {
        boxShadow: 'none',
        outlineColor: 'primary.300',
        outlineWidth: '2px',
        outlineStyle: 'solid',
      },
      _focusVisible: {
        boxShadow: 'none',
        outlineColor: 'primary.300',
        outlineWidth: '2px',
        outlineStyle: 'solid',
      },
      _disabled: {
        bg: 'borderNeutralPrimaryMediumContrast',
      },
    },
  },
};

export type QuotientSwitchProps = {
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  children?: string | null;
  showLabelFirst?: boolean;
  spacing?: string;
  textStyle?: keyof typeof textStyles;
  wide?: boolean;
} & SelectedStyledSystemProps &
  CommonCIQProps;

export const QuotientSwitch: FC<QuotientSwitchProps> = ({
  isChecked,
  isDisabled,
  onChange,
  children,
  showLabelFirst,
  textStyle = 'bodyRegular',
  wide,
  ...props
}) => {
  const direction = showLabelFirst ? 'row-reverse' : 'row';
  return (
    <FormControl alignItems="center" display="flex" width="100%">
      <Flex alignItems="center" direction={direction} gap={2} justifyContent={wide ? 'space-between' : ''} width="100%">
        <ChakraSwitch isChecked={isChecked} isDisabled={isDisabled} mb={0} onChange={onChange} {...props} />
        <FormLabel color={isDisabled ? 'textLowContrast' : 'textHighContrast'} m={0} {...textStyles[textStyle]}>
          {children}
        </FormLabel>
      </Flex>
    </FormControl>
  );
};
